import * as R from 'ramda';

/**
 *
 * @param {any} x
 * @return {Array<String>} errors
 */
export const getGraphqlErrorMessages = R.pipe(R.propOr([], 'graphQLErrors'), R.map(R.propOr('', 'message')));
